import { Observable } from 'rxjs';
import { InjectionToken } from '../../injection';
import { EmptyResponse } from '../data/empty-response.do';
import { OrganizationMembership } from '../data/organization-membership.do';

export interface IMembershipService {
  delete(membershipId: string): Observable<EmptyResponse>;
  update(membership: OrganizationMembership): Observable<OrganizationMembership>;
}
export const IMembershipService = new InjectionToken('IMembershipService');
